import React from "react";
import ReactDom from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import MainContainer from "./components/MainContainer";
import Sales from "./components/pages/Sales";
import MonthlyExpenditure from "./components/pages/GetReportTabs/MonthlyExpenditure";
import EventSos from "./components/pages/EventSos";
import { PermissionContextProvider } from "./Store/permission-context";

ReactDom.render(
  <PermissionContextProvider>
    <BrowserRouter basename="/">
      <div>
        <MainContainer />
        {/* <EventSos /> */}
      </div>
    </BrowserRouter>
  </PermissionContextProvider>,
  document.getElementById("root"),
);
